<script setup lang="ts">
import type { IconKeys, IconSize } from "./Icon.interface"
import { computed } from "vue"
import * as Icons from "./icons"

interface IconProps {
  icon: IconKeys
  size?: IconSize
}

const props = withDefaults(defineProps<IconProps>(), {
  size: "default",
})

const icon = computed(() => Icons[props.icon])
</script>

<template>
  <component
    :is="icon" class="shrink-0 fill-current" :class="{
      'w-4 h-4': size === 'xs',
      'w-5 h-5': size === 'sm',
      'w-6 h-6': size === 'default',
      'w-8 h-8': size === 'lg',
      'w-14 h-14': size === 'xl',
      'w-24 h-24': size === '2xl',
      'w-32 h-32': size === '4xl',
    }"
  />
</template>
